import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FormControl, FormHelperText, FormLabel } from '@chakra-ui/react';

import { useAppSelector } from '@/store';
import { AdAttribute, AdStepItem } from '@/store/ad/types';
import { AttributeInput } from './components';

export type AttributeFormControlProps = {
  attribute: AdAttribute;
  parentAttribute?: AdAttribute;
  stepItem: AdStepItem;
};

export const AttributeFormControl: FC<AttributeFormControlProps> = ({ attribute, parentAttribute }) => {
  const { t } = useTranslation();
  const { formData } = useAppSelector((state) => state.ad);

  const requiresParentEntry = useMemo(() => {
    if (!parentAttribute) {
      return false;
    }
    return !formData[parentAttribute.id]?.entries?.length;
  }, [formData, parentAttribute]);

  if (!attribute) return null;

  const showLabel = attribute.type !== 'Boolean';

  return (
    <FormControl isRequired={attribute.mandatory} isReadOnly={requiresParentEntry} mb={4}>
      {showLabel && <FormLabel>{attribute.name}</FormLabel>}
      <AttributeInput attribute={attribute} parentAttribute={parentAttribute} />

      {requiresParentEntry && (
        <FormHelperText>{t('ad.steps.attributes.parentRequired', { name: parentAttribute?.name })}</FormHelperText>
      )}
    </FormControl>
  );
};
